/* eslint-disable max-len, no-shadow, global-require */

if (typeof window !== 'undefined') {
  require('owl.carousel');
}


const configurationKeys = [
  'items',
  'margin',
  'loop',
  'center',
  'mouseDrag',
  'touchDrag',
  'pullDrag',
  'freeDrag',
  'stagePadding',
  'merge',
  'mergeFit',
  'autoWidth',
  'startPosition',
  'URLhashListener',
  'nav',
  'rewind',
  'navText',
  'navElement',
  'slideBy',
  'slideTransition',
  'dots',
  'dotsEach',
  'dotsData',
  'lazyLoad',
  'lazyLoadEager',
  'autoplay',
  'autoplayTimeout',
  'autoplayHoverPause',
  'smartSpeed',
  'fluidSpeed',
  'autoplaySpeed',
  'navSpeed',
  'dotsSpeed',
  'dragEndSpeed',
  'callbacks',
  'responsive',
  'responsiveRefreshRate',
  'responsiveBaseElement',
  'video',
  'videoHeight',
  'videoWidth',
  'animateOut',
  'animateIn',
  'fallbackEasing',
  'info',
  'nestedItemSelector',
  'itemElement',
  'stageElement',
  'navContainer',
  'dotsContainer',
  'checkVisible',
  'Classes'
].reduce((obj, item) => {
  // eslint-disable-next-line no-param-reassign
  obj[item.toLowerCase()] = item;
  return obj;
}, {});

function parseValue(string) {
  const trimmed = string.trim ? string.trim() : string;
  const values = {
    false: false,
    true: true
  };
  /* eslint-disable no-nested-ternary */
  return Object.keys(values).includes(trimmed)
    ? values[trimmed]
    : (
      Number.isNaN(parseInt(trimmed, 10))
        ? trimmed
        : parseInt(trimmed, 10)
    );
  /* eslint-enable no-nested-ternary */
}

function assignValue(obj, key, value) {
  const normalizedKey = (configurationKeys[key] || key).trim();
  // eslint-disable-next-line no-param-reassign
  obj[normalizedKey] = parseValue(value);
  return obj;
}

function parseString(string) {
  return string.split(',').reduce(
    (obj, pairString) => {
      const [key, value] = pairString.split(':');
      if (key && value) {
        assignValue(obj, key, value);
      }
      return obj;
    }, {}
  );
}

function getConfiguration(obj) {
  return Object.keys(obj).reduce(
    (configuration, key) => {
      if (key === 'options') {
        return Object.assign(configuration, parseString(obj[key]));
      }
      if (key.indexOf('responsive') === 0) {
        const breakpoint = key.split('_')[1];
        if (breakpoint) {
          return Object.assign(
            configuration,
            {
              responsive:
                Object.assign(
                  configuration.responsive || {},
                  { [breakpoint]: parseString(obj[key]) }
                )
            }

          );
        }
      }
      assignValue(configuration, key, obj[key]);
      return configuration;
    },
    {}
  );

}

function setAnimationState(element, state) {
  $(element).find('.dc-slider__progressbar').css({
    '-webkit-animation-play-state': state,
    'animation-play-state': state
  });
}

const classes = {
  refreshClass: 'dc-owl-refresh',
  loadingClass: 'dc-owl-loading',
  loadedClass: 'dc-owl-loaded',
  rtlClass: 'dc-owl-rtl',
  dragClass: 'dc-owl-drag',
  grabClass: 'dc-owl-grab',
  stageClass: 'dc-owl-stage',
  stageOuterClass: 'dc-owl-stage-outer',
  navContainerClass: 'dc-slider__nav',
  navClass: ['dc-slider__prev', 'dc-slider__next'],
  controlsClass: 'dc-slider__controls',
  dotClass: 'dc-slider__dot',
  dotsClass: 'dc-slider__dots',
  autoHeightClass: 'dc-slider-height',
  responsiveClass: 'dc-owl-responsive',
  itemClass: 'dc-owl-item'
};

export function initSliders(element) {
  const sliderElement = $(element);

  sliderElement.find('.dc-tabbed-slider').each((index, tabbedSlider) => {
    init(tabbedSlider.getAttribute('id'), $.extend({}, classes, {
      items: 1,
      slideBy: 'page',
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      autoplay: true,
      loop: true,
      autoplayHoverPause: true,
      tabs: true,
      autoplayTimeout: 3000,
      dots: false,
      navText: ['<i class="icon-chevron-left"></i>', '<i class="icon-chevron-right"></i>']
    }, getConfiguration($(`#${tabbedSlider.getAttribute('id')}`).data())));
  });
  sliderElement.find('.dc-tabbed-slider').addClass('dc-owl');
  sliderElement.find('.dc-slider').each((index, slider) => {
    init(slider.getAttribute('id'), $.extend({}, classes, {
      loop: true,
      autoplay: true,
      pagination: false,
      autoplaySpeed: 500,
      scrollPerPage: true,
      items: 4,
      slideBy: 'page',
      itemsTablet: [768, 3],
      autoplayHoverPause: true,
      autoplayTimeout: 5000,
      nav: true,
      dots: false,
      navText: ['<i class="icon-chevron-left"></i>', '<i class="icon-chevron-right"></i>'],
      margin: 10
    }, getConfiguration($(`#${slider.getAttribute('id')}`).data())));
  });
  sliderElement.find('.dc-slider').addClass('dc-owl');

  resizeImages(sliderElement);

  window.addEventListener('resize', () => {
    resizeImages(sliderElement);
  });
}

function resizeImages(sliderElement) {
  sliderElement.find('img.respImg')
    .each((i, element) => {
      const currentImage = $(element);

      if (window.innerWidth > 599) {
        if (typeof currentImage.attr('data-small') === 'undefined') {
          currentImage.attr('data-small', currentImage.attr('src'));
        }

        currentImage.attr('src', currentImage.attr('data-big'));
      } else if (typeof currentImage.attr('data-small') !== 'undefined') {
        currentImage.attr('src', currentImage.attr('data-small'));
      }
    });
}

function init(id, options) {
  const slidesSelector = `#${id}>.dc-slider__slides`;
  const tabsSelector = `#${id}>.dc-slider__tabs`;
  // eslint-disable-next-line no-param-reassign
  options.onInitialized = (event) => {
    $(`#${id}>.dc-slider__slides img`).on('load', setHeight);
    setTimeout(setHeight, 0);
    $(`${slidesSelector}`).append(`
      <div class="dc-slider__progress">
        <div class="dc-slider__progressbar ${event.relatedTarget.settings.autoplay ? 'animate' : ''}" 
          style="-webkit-animation-duration: ${options.autoplayTimeout}ms; animation-duration: ${options.autoplayTimeout}ms">
        </div>
      </div>
    `);
    let activeTabExist = false;
    $(`${tabsSelector} .dc-slider__tab`).each((index, element) => {
      const slideIndex = element.getAttribute('data-slide') || index;
      const hash = element.getAttribute('data-hash');
      $(element).wrapInner(`<div class="dc-slider__tab-content"><a data-slide='${slideIndex}'></a></div>`);
      if (
        slideIndex === event.relatedTarget.settings.startPosition ||
        (
          event.relatedTarget.settings.startPosition === 'URLHash' &&
          (`#${hash}` === (window && window.location.hash))
        )
      ) {
        activeTabExist = true;
        $(element).addClass('active');
      }
    });
    if (!activeTabExist) {
      $($(`${tabsSelector} .dc-slider__tab`)[0]).addClass('active');
    }
  };
  // eslint-disable-next-line no-param-reassign
  options.onChanged = (event) => {
    if (
      event.property.name === 'settings'
    ) {
      extendOwlCarousel(event.property.value);
    }
  };
  // eslint-disable-next-line no-param-reassign
  options.onResized = () => {
    setTimeout(setHeight, 0);
  };
  // eslint-disable-next-line no-param-reassign
  options.onTranslate = (event) => {
    const options = event.relatedTarget.settings;
    if (options.autoplay && options.progress) {
      $(`${slidesSelector} .dc-slider__progressbar`).removeClass('animate').width();
      $(`${slidesSelector} .dc-slider__progressbar`).addClass('animate');
    }
    if (options.tabs) {
      $(`${tabsSelector} .dc-slider__tab`).removeClass('active');
      $(`${tabsSelector} .dc-slider__tab [data-slide='${event.page.index}']`).parents('li').addClass('active');
    }
  };

  function setHeight() {
    const height = $(`#${id}>.dc-slider__slides .dc-slider__slide`).height();
    $(tabsSelector).height(height);
    const tabHeight = height / $(`${tabsSelector} .dc-slider__tab`).length;
    $(`${tabsSelector} .dc-slider__tab a`).css({ 'line-height': `${tabHeight}px`, 'height': `${tabHeight}px` });
  }

  function extendOwlCarousel(options) {
    if (options.tabs) {
      $(`#${id}`).addClass('dc-slider--with-tabs');
      $(`${tabsSelector} .dc-slider__tab`).on('click', (event) => {
        $(slidesSelector).trigger('to.owl.carousel', parseInt(event.target.getAttribute('data-slide'), 10));
      });
    } else {
      $(`#${id}`).removeClass('dc-slider--with-tabs');
    }
    if (options.nav) {
      $(`#${id}`).addClass('dc-slider--with-nav');
      $(`#${id} .dc-slider__prev`).addClass('dc-slider__prev');
      $(`#${id} .dc-slider__next`).addClass('dc-slider__next');
    } else {
      $(`#${id}`).removeClass('dc-slider--with-nav');
    }
    if (options.progress && options.autoplay) {
      $(`#${id}`).addClass('dc-slider--with-progress');
      $(`${slidesSelector} .dc-slider__progressbar`).addClass('animate');
    } else {
      $(`#${id}`).removeClass('dc-slider--with-progress');
      $(`${slidesSelector} .dc-slider__progressbar`).removeClass('animate');
    }
    if (options.dots) {
      $(`#${id}`).addClass('dc-slider--with-dots');
    } else {
      $(`#${id}`).removeClass('dc-slider--with-dots');
    }
  }

  $(slidesSelector).addClass('owl-carousel');
  $(slidesSelector).owlCarousel(options);

  $(slidesSelector).on('mouseover.owl.autoplay', (event) => {
    setAnimationState(event.currentTarget, 'paused');
  });

  $(slidesSelector).on('mouseleave.owl.autoplay', (event) => {
    setAnimationState(event.currentTarget, 'running');
  });

  $(tabsSelector).on('mouseover', () => $(slidesSelector).trigger('mouseover.owl.autoplay'));
  $(tabsSelector).on('mouseleave', () => $(slidesSelector).trigger('mouseleave.owl.autoplay'));

}
